module.exports = __webpack_public_path__ + "assets/img/partners3.e037ec1c.jpg";